const isDev = import.meta.env.DEV;

export function debugLog(namespace: string, ...args: unknown[]): void {
  if (isDev) {
    console.log(`[${namespace}]`, ...args);
  }
}

export function debugWarn(namespace: string, ...args: unknown[]): void {
  if (isDev) {
    console.warn(`[${namespace}]`, ...args);
  }
}

export function debugError(namespace: string, ...args: unknown[]): void {
  console.error(`[${namespace}]`, ...args);
}
